// Keeps user image events known but invisible until attachment presentation
// enters the V3 scope.
import { z } from 'zod';

import { defineInvisible } from '@apps/web/features/phoebe_chat_v3/registry/types';

const userImagePayloadSchema = z.object({ image_url: z.string() }).strip();

export const userImageDefinitions = {
    user_image: defineInvisible('user_image', {
        disposition: 'invisible',
        schema: userImagePayloadSchema,
        malformed: { kind: 'skip' },
        evidence: null,
    }),
} as const;

export const userImageContractFixtures = {
    valid: { image_url: 'https://example.invalid/user-image.png' },
    malformed: { image_url: 7 },
} as const;
